import React from 'react';
import { User, Users, Layout, Home, FileText, MapPin, Navigation, Phone } from 'lucide-react';
import InputField from './common/InputField';

const LandOwnerFields = ({ handleInputChange, errors = {} }) => {
    return (
        <>
            <InputField
                label="Land Owner Name"
                name="landOwnerName"
                placeholder="Enter owner name"
                icon={User}
                required
                error={errors.landOwnerName}
                onChange={handleInputChange}
            />

            <div className="flex flex-col sm:flex-row divide-y sm:divide-y-0 sm:divide-x divide-gray-100">
                <InputField
                    label="Pincode"
                    name="pincode"
                    type="number"
                    placeholder="e.g. 400050"
                    icon={MapPin}
                    required
                    error={errors.pincode}
                    onChange={handleInputChange}
                />
                <InputField
                    label="Number of Tenants"
                    name="totalTenants"
                    type="number"
                    placeholder="Count"
                    icon={Users}
                    onChange={handleInputChange}
                />
            </div>

            <div className="flex flex-col sm:flex-row divide-y sm:divide-y-0 sm:divide-x divide-gray-100">
                <InputField
                    label="Plot Area (sq. metre)"
                    name="plotArea"
                    type="number"
                    placeholder="Area in sq.m"
                    icon={Layout}
                    onChange={handleInputChange}
                />
                <InputField
                    label="Members Occupied Area"
                    name="occupiedArea"
                    type="number"
                    placeholder="Area"
                    icon={Home}
                    onChange={handleInputChange}
                />
            </div>

            <InputField
                label="Plot Details (CTS/CS/Plot No.)"
                name="plotDetails"
                placeholder="Enter plot details"
                icon={FileText}
                onChange={handleInputChange}
            />

            <div className="flex flex-col sm:flex-row divide-y sm:divide-y-0 sm:divide-x divide-gray-100">
                <InputField
                    label="Division"
                    name="division"
                    placeholder="e.g. Andheri, Khar"
                    icon={MapPin}
                    required
                    error={errors.division}
                    onChange={handleInputChange}
                />
                <InputField
                    label="Ward"
                    name="ward"
                    placeholder="e.g. HE, HW"
                    icon={Navigation}
                    onChange={handleInputChange}
                />
            </div>

            <InputField
                label="Contact Number"
                name="contact"
                type="tel"
                placeholder="Mobile / Landline"
                icon={Phone}
                required
                error={errors.contact}
                onChange={handleInputChange}
            />
        </>
    );
};

export default LandOwnerFields;
